import script from "./ConnectedSocialPagesItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectedSocialPagesItem.vue?vue&type=script&lang=ts&setup=true"

import "./ConnectedSocialPagesItem.vue?vue&type=style&index=0&id=4cbec818&lang=sass"

const __exports__ = script;

export default __exports__